module.exports = __webpack_public_path__ + "img/bsjg_07.050b0553.png";